import { useEffect } from 'react';

import usePrevious from '#/utils/usePrevious';

import { useAccountView } from '#/features/account/account-context';
import { publishNotification } from '#/features/notifications/topic';

export function useAccountNotifications() {
  useAccountLiquidationListener();
}

function useAccountLiquidationListener(): void {
  const isTransitionedToBeingLiquidated = useIsTransitionedToBeingLiquidated();

  useEffect(() => {
    if (!isTransitionedToBeingLiquidated) return;

    publishNotification({
      kind: 'account-is-being-liquidated',
      props: {},
    });
  }, [isTransitionedToBeingLiquidated]);
}

function useIsTransitionedToBeingLiquidated() {
  const accountView = useAccountView();
  const prevIsBeingLiquidated = usePrevious(accountView.isBeingLiquidated);

  if (prevIsBeingLiquidated == null) {
    return accountView.isBeingLiquidated;
  }

  return !prevIsBeingLiquidated && accountView.isBeingLiquidated;
}
